module.exports = __webpack_public_path__ + "img/img (30).dbb6c120.jpg";